import { useState } from "react";
import { AppBar, Toolbar, Button, Menu, MenuItem } from "@mui/material";
import USFlag from "assets/images/flags/US.svg";
import SAFlag from "assets/images/flags/SA.svg";
import LogoutIcon from "assets/icons/logout.svg";
import { useNavigate } from "react-router-dom";
import { removeToken } from "services/tokenUtils";

import { useTranslation } from "react-i18next";

/**
 * language selection and logout actions for the site.
 */
const Navbar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [logoutAnchorEl, setLogoutAnchorEl] = useState(false);
  const navigate = useNavigate();

  const { i18n, t } = useTranslation();
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  /**
   * Switches the site language and updates related settings.
   * The language code to switch to ("en" or "ar").
   */
  const switchLanguage = (langCode) => {
    if (!langCode) return;
    i18n.changeLanguage(langCode);
    document.documentElement.dir = langCode === "ar" ? "rtl" : "ltr";
    localStorage.setItem("language", langCode);
    setAnchorEl(null);
  };

  const handleLogoutClick = () => {
    setLogoutAnchorEl(true);
  };

  const handleLogoutClose = () => {
    setLogoutAnchorEl(false);
  };

  /**
   * Logs the user out, removes the authentication token, and navigates to the sign-in page.
   */
  const handleConfirmLogout = () => {
    removeToken();
    navigate("/sign-in");
    handleLogoutClose();
  };

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: "background.white",
        boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "flex-end" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <Button
            onClick={handleMenuClick}
            sx={{
              color: "secondary.main",
              border: "1px solid",
              borderColor: "secondary.main",
              textTransform: "none",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              padding: "0.5rem 1rem",
            }}
          >
            <img
              src={i18n.language === "ar" ? SAFlag : USFlag}
              alt={i18n.language === "ar" ? "Arabic" : "English"}
              style={{ width: "20px", height: "20px" }}
            />
            {i18n.language ? i18n.language.toUpperCase() : "EN"}{" "}
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={() => switchLanguage("en")}>
              <img
                src={USFlag}
                alt="English"
                style={{ width: "20px", height: "20px", marginRight: "0.5rem" }}
              />
              EN
            </MenuItem>
            <MenuItem onClick={() => switchLanguage("ar")}>
              <img
                src={SAFlag}
                alt="Arabic"
                style={{ width: "20px", height: "20px", marginRight: "0.5rem" }}
              />
              AR
            </MenuItem>
          </Menu>

          <Button
            onClick={handleConfirmLogout}
            sx={{
              color: "secondary.main",
              border: "1px solid",
              borderColor: "secondary.main",
              textTransform: "none",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              padding: "0.5rem 1rem",
            }}
          >
            <img
              src={LogoutIcon}
              alt="Logout"
              style={{
                width: "20px",
                height: "20px",
                filter: "invert(0) brightness(0)",
              }}
            />
            {t("logout")}
          </Button>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
